import localForage from 'localforage';

import 'localforage-getitems';
import 'localforage-setitems';
import 'localforage-removeitems';

export default (options: any) => {
  let _options = {};
  let _storageInstance = localForage;

  if (options.name) {
    _options['name'] = options.name;
    _storageInstance = localForage.createInstance(_options);
  }
  else {
    _storageInstance.config(_options);
  }

  return _storageInstance;
};
